<template lang="pug">
	.voice-creator--audio-recorder
		.flex-row.space-medium.align-center(v-if="!hideUI")
			audio(v-if="link", :src="link", controls)
			.flex-row.space(v-if="!readonly")
				DxButton.small(icon="fas fa-microphone 2xs", :hint="$tCaption('Record')", :text="recordText", @click="show")
				slot(name="actions")
		Popup(v-if="recPopupVisible", :popupVisible.sync="recPopupVisible", classes="tracker-dark", :width="hasSpeakingText ? 920 : 480", :autosize="true", :closeOnOutsideClick="false", @hiding="onHiding")
			.voice-creator--audio-recorder
				AudioTrackerRecorder(v-bind="$props", ref="recorder", @result-wav="base64 => hasResult = !!base64", @is-recording="v => hasResult = hasResult || v", :showTitle="false",
					:hideAudioTools="true", :readonly="readonly")
					template(slot="top", v-if="$scopedSlots['text']")
						slot(name="text")
					.flex-row.align-center.space(slot="actions-end")
						DxButton(v-if="!readonly", icon="upload", :text="$tCaption('Upload', '@actions')", @click="$refs.uploader.showPopup()")
						slot(name="actions-end")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", icon="save", type="success", @click="save", :disabled="!(hasResult || file) || readonly")
				DxButton(v-if="!readonly && showNext", type="success", icon="fas fa-chevron-right", :text="$tCaption('Next', '@actions')", @click="$emit('next')")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="cancel")
		Loader(v-if="isLoading", :fullscreen="true")
		FileUploader(ref="uploader", :isUIHidden="true", @upload="onFileUpload")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import Loader from 'app-core/Loader.vue';	
	import Popup from 'app-core/Popup.vue';
	import AudioTrackerRecorder from 'view/audioTracker/AudioTrackerRecorder.vue';
	import FileUploader from 'app-core/FileUploader.vue';

	export default {
		translationCategory: 'voiceCreator.AudioRecorder',
		name: 'voice-creator--audio-recorder',
		components: {
			DxButton, Loader, DxTextBox, DxTextArea, Popup, AudioTrackerRecorder, FileUploader
		},
		props: ['link', 'text', 'recordText', 'hideUI', 'readonly', 'showNext'],
		data() {
			return {
				isLoading: 0,
				recPopupVisible: false,
				hasResult: false,
				file: null
			};
		},
		computed: {
			isLoadingCssClass() {
				return { 'disabled-controls': this.isLoading };
			},
			hasSpeakingText() {
				return !!this.text || !!this.$scopedSlots['text'];
			}
		},
		watch: {
			
		},
		mounted() {
		},
		destroyed() {
			this.stopRecording();
		},
		methods: {
			startRecording() {
				if (this.$refs.recorder) {
					this.$refs.recorder.startRecording();
				}
			},
			onFileUpload(files) {
				if (__DEBUG__)
					console.debug('onFileUpload', { files });
				this.file = files ? files[0] : null;
			},
			show() {
				if (__DEBUG__)
					window.vcAudioRecorder = this;
				this.recPopupVisible = false;
				this.hasResult = false;
				this.file = null;
				this.$nextTick(() => {
					this.recPopupVisible = true;
					this.clearResults();
				});
				this.$emit('show');
			},
			clearResults() {
				this.$nextTick(() => {
					this.hasResult = false;
					this.file = null;
					if (this.$refs.recorder?.resultBlob) {
						this.$refs.recorder.resultBlob = null;
					}
				});
			},
			onHiding(v) {
				if (!v) this.stopRecording()
			},
			async stopRecording() {
				return this.$refs.recorder && await this.$refs.recorder.stopRecording(true);
			},
			cancel() {
				this.stopRecording();
				this.recPopupVisible = false;
			},
			async getFinalAudio() {
				if (this.file && !this.hasResult) {
					return this.file;
				} else {
					const instance = this.$refs.recorder;
					if (instance.recorder.isRecording) {
						await instance.stopRecording();
						return instance.recorder.resultBlob;
					} else {
						return null;
					}
				}
			},
			async save() {
				let result = await this.getFinalAudio();
				if (result) {
					this.$emit('save', result);
				}
				this.recPopupVisible = false;
			},
			reinit() {
				if (!this.$refs.recorder) return;
				this.$refs.recorder.stopRecording(true);
				this.$refs.recorder.initRecorder(this.$refs.recorder.recorder);
				this.hasResult = false;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.voice-creator--audio-recorder {
		audio::-webkit-media-controls-play-button,
		audio::-webkit-media-controls-panel {
			background-color: #fff;
			color: #000;
		}
	}
</style>
 